var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._b({ref:"fileInput",staticClass:"file-input",attrs:{"accept":_vm.fileTypes,"multiple":_vm.multiple,"type":"file","name":"file-input"},on:{"change":_vm.uploadLocalFiles}},'input',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }